import { render, staticRenderFns } from "./ResponsibilityFormModal.vue?vue&type=template&id=4ec43892&"
import script from "./ResponsibilityFormModal.vue?vue&type=script&lang=js&"
export * from "./ResponsibilityFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports